import { Input, OnChanges, Directive, SimpleChanges, Injector } from '@angular/core';
import { IWidgetSettingsModel } from '@fi-shared/widget/widget-settings.model';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { WidgetSharedService } from '@fi-shared/widget/widget-shared.service';

@Directive()
export class WidgetSettingsControlBase implements OnChanges {
    private widgetSharedService: WidgetSharedService;

    constructor(injector: Injector) {
        this.widgetSharedService = injector.get(WidgetSharedService);
    }

    @Input('settings') Settings: IWidgetSettingsModel;
    @Input() widgetMode: boolean = false;
    @Input() isStartPage: boolean = false;
    @Input() widgetControl: WidgetPlaceHolderControlModel;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.Settings && !changes.Settings.firstChange) {
            this.settingsOnChange();
        }
    }

    settingsOnChange() {
        this.settingsPropertyOnChange();
    }

    onSelectedTagsChange($event) {
        this.widgetControl.TagIds = $event;
        this.settingsPropertyOnChange();
    }

    public settingsPropertyOnChange(data?: { skipReloadData?: boolean }) {
        this.widgetSharedService.raiseWidgetSettingsChanged(this.Settings, data);
    }
}
